<div class="status-badge" [ngClass]="getStatusColor(_value)" [ngStyle]="{
          'color': '#fff'
        }">
  {{ _value }}
</div>